import React from 'react';
import {hideShowLink} from './../../../editor/senses/SenseAction';
import Dict from 'dict-lib';
import {Button, Row, Col} from 'react-bootstrap';
import './../../../../../_css/lexeme.css';


export class SenseHideLink extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
        };

        this._handleHideShow = this._handleHideShow.bind(this);
    }

    _handleHideShow(item, ids) {
        item = JSON.stringify(item);

        this.setState({btDisabled: true});
        hideShowLink(item, ids).then(result => {
            this.setState({btSaveState: "success", btDisabled: false}, function () {
                setTimeout(function () {
                    this.setState({btSaveState: "primary"});
                }.bind(this), 1000);
            });
        });
    }

    render() {

        return <div className="locVar-delete">
            <Row>
                <Col lg={7} md={7} className="popup-label">{Dict.t('ASK_DELETEP_LINK')}</Col>
                <Col lg={5} md={5}>
                    <Button bsStyle={this.state.btSaveState} onClick={() => this._handleHideShow(this.props.item, this.props.additionalData.ids)}>{Dict.t('YES')}</Button>
                </Col>
            </Row>
        </div>;
    }


}
